angular.module('zc.master.projects')

.controller('MasterCampaignSegmentDetailCtrl', (
    $scope,
    $state,
    $stateParams,
    $translate,
    Page,
    FacadeV2,
    MasterCampaign,
    Project,
    CampaignSegment,
    currentCampaign,
    currentProject) ->
  Page.setBodyClass ''
  $translate('masterProjects.masterCampaignSegmentDetail.listDeliveryConditionSettings').then (translation) ->
    Page.setTitle translation

  $scope.currentCampaign = currentCampaign
  $scope.currentProject = currentProject

  $scope.tuneSmartRandom = () ->
    Project.update({
      projectId: $scope.currentProject.id
    }, {
      project: $scope.currentProject
    })
    .then (project) ->
      $scope.currentProject = project
      # Call facade api to regerate timing
      # TODO: Done directly with FacadeV2.
      # Move to service after masteradmin-webpack is done
      FacadeV2.request("/apikeys/#{$scope.currentProject.apikey}/zcs_timings/generate_smart_random", { method: 'POST' })
    .then (res) ->
      if res.success
        console.error("failed", res)
        return

      # TODO: get new timing and update view
      MasterCampaign.get({projectId: $scope.currentProject.id, campaignId: $scope.currentCampaign.id})
      .then (campaign) ->
        console.log campaign
        $scope.currentCampaign = campaign


  $scope.isOldCampaign = () ->
    !$scope.currentCampaign.segment || $scope.currentCampaign.segment.segment_type == 'custom_old'

)



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.projects/master_campaign_segment_detail.controller.js.coffee